module.exports = __webpack_public_path__ + "static/img/booking-com.2aa63cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/booking-com.png
// module id = kI/l
// module chunks = 0